export interface IOutOfHomeActivity {
    Id?: string;
    SubscriberId?: string;
    Name: string;
    StartDateTime: string;
    EndDateTime?: string | null;
}

export class OutOfHomeActivity implements IOutOfHomeActivity {
    Id?: string = undefined;
    SubscriberId?: string = undefined;
    Name: string = '';
    StartDateTime: string = '';
    EndDateTime?: string | null = null;

    constructor(jsonObject?: IOutOfHomeActivity) {
        !!jsonObject && this.jsonToClassAdapter(jsonObject);
    }

    private jsonToClassAdapter = (jsonObject: IOutOfHomeActivity) => Object.keys(this).forEach(prop => this[prop] = jsonObject[prop])
}